import { render, staticRenderFns } from "./Navs.vue?vue&type=template&id=73f5d9fb&scoped=true&"
import script from "./Navs.vue?vue&type=script&lang=ts&"
export * from "./Navs.vue?vue&type=script&lang=ts&"
import style0 from "./Navs.vue?vue&type=style&index=0&id=73f5d9fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5d9fb",
  null
  
)

export default component.exports